import React from 'react';
import { dayjs } from 'shared/utils/date';
import { CalendarOutlined } from '@ant-design/icons';
import { PERIOD, PERIOD_TYPE, calculateDateRanges, formatDateRange } from 'shared/constants/date';
import useFormatMessage from 'hooks/useFormatMessage';
import messages from './messages';

function getPeriodLabel($t, periodType, period, lastNumberInput) {
  switch (periodType) {
    case PERIOD_TYPE.LAST:
      if (lastNumberInput === 1 && period === PERIOD.DAY) {
        return $t(messages.yesterday);
      }
      return `${$t(messages.last)} ${lastNumberInput > 1 ? `${lastNumberInput} ${$t(messages[`${period}s`] || messages.dateRanges)}` : $t(messages[period] || messages.dateRanges)}`;
    case PERIOD_TYPE.THIS:
      if (lastNumberInput === 1 && period === PERIOD.DAY) {
        return $t(messages.today);
      }
      return `${$t(messages.this)} ${$t(messages[period])}`;
    case PERIOD_TYPE.FIXED:
      return $t(messages.fixed);
    case PERIOD_TYPE.FIXED_WEEKS:
      return $t(messages.fixedWeeks);
    default:
      return '';
  }
}

export const PeriodLabel = ({
  dateRange: { periodType, period, lastNumberInput },
}) => {
  const $t = useFormatMessage();
  const label = getPeriodLabel($t, periodType, period, lastNumberInput);

  return <div className="date-range-picker__period">{label}</div>;
};

export const PreviewDate = ({ period, startDate, endDate }) => {
  const formatted = formatDateRange(dayjs, period, startDate, endDate, { locale: 'en-gb' });

  return (
    <div className="date-range-picker__preview">
      <CalendarOutlined style={{ marginRight: 5 }} />
      {formatted}
    </div>
  );
};

const PreviewDates = ({ dateRange, mainOnly, compareOnly, ...rest }) => {
  let dateRanges = calculateDateRanges(dayjs, dateRange);
  if (mainOnly) {
    dateRanges = [dateRanges[0]];
  } else if (compareOnly) {
    dateRanges = dateRanges.slice(1);
  }
  return (
    <div className="date-range-picker__previews" {...rest}>
      {dateRanges.map((dr, i) => (
        <PreviewDate key={i} period={dr.period} startDate={dr.startDate} endDate={dr.endDate} />
      ))}
    </div>
  );
};

export default PreviewDates;
